// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__K4-m8","label":"styles_label__3KWAH"};